'use client';

import { TID } from '@atproto/common-web';
import { at } from '@pylon/protocol';
import { ReactNode, useContext, useState } from 'react';
import { AgentCtx, Agent } from '../agent';

export function CreateDeveloperForm(): ReactNode {
  const agent = useContext(AgentCtx)!;

  const [name, setName] = useState('');

  return <>
    <form onSubmit={(e) => { e.preventDefault(); createDeveloper(agent, name); }}>
      <label>Name:
        <input type='text' value={name} onChange={(e) => setName(e.target.value)} />
      </label>
      <button type='submit'>Create developer.</button>
    </form>
  </>;
}

async function createDeveloper(
  agent: Agent,
  name: string,
): Promise<void> {
  const developer = at.pylon.temp.developer.$build({ name });
  console.log(developer);

  const tid = TID.nextStr();
  console.log(tid);

  const putRes = await agent.com.atproto.repo.putRecord({
    repo: agent.did,
    collection: 'at.pylon.temp.developer',
    rkey: tid,
    record: developer,
  });
  console.log(putRes.data);

  const getRes = await agent.com.atproto.repo.getRecord({
    repo: agent.did,
    collection: 'at.pylon.temp.developer',
    rkey: tid,
  });
  console.log(getRes.data);
}
